export const getUrlParams = (state: any) => state.mobileKeyboard.urlParams;
export const getPublishTopic = (state: any) => state.mobileKeyboard.publishTopics;
export const getReconnectCount = (state: any) => state.mobileKeyboard.reconnectCount;
export const getMqttStatus = (state: any) => state.mobileKeyboard.mqttStatus;
export const getConnectionStatus = (state: any) => state.mobileKeyboard.connectionStatus;
export const getIsFirstConnectionAttempt = (state: any) => state.mobileKeyboard.firstConnectionAttempt;